import React, { useEffect } from 'react'
import Footer from '../core/Footer'
import { Navbar } from '../core/Navbar'
import { Content } from '../sections/clients/Content'

export const Clients = () => {
  useEffect(() => {
    document.title = "Clients - Four Fox Security Pvt. Ltd.";
  }, []);

  return (
    <div>
      <Navbar />
      <Content />
      <Footer />
    </div>
  )
}
